<template>
    <div id="app">
        <AuthProvider>
            <WorkspaceProvider>
                <GlobalPermissionsProvider :fetch-method="fetchGlobalPermissions">
                    <SocketProvider application="crm">
                        <router-view :key="$route.fullPath" />
                    </SocketProvider>
                </GlobalPermissionsProvider>
            </WorkspaceProvider>
        </AuthProvider>
    </div>
</template>

<script>
import { AuthProvider } from '@speechki-frontend/core/auth/components';
import { GlobalPermissionsProvider } from '@speechki-frontend/core/auth/components';

import WorkspaceProvider from './workspaces/components/WorkspaceProvider/WorkspaceProvider';
import { fetchGlobalPermissions } from './utils/api/permissions';
import { SocketProvider } from '@speechki-frontend/core/socket';

export default {
    name: 'App',
    components: {
        GlobalPermissionsProvider,
        WorkspaceProvider,
        AuthProvider,
        SocketProvider,
    },
    methods: {
        fetchGlobalPermissions,
    },
};
</script>

<style lang="scss" src="@speechki-frontend/shared/assets/scss/common.scss"></style>
